module.exports = __webpack_public_path__ + "img/sandport-wheat-off-the-wall.0b0521da.png";